"use client";
import React, { useState } from 'react';
import { Cookie, X } from 'lucide-react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(true);
  const [showDetails, setShowDetails] = useState(false);

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slide-up">
      <div className="max-w-4xl mx-auto bg-gray-900 text-white rounded-2xl shadow-modal p-5">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 p-2 bg-amber-500 rounded-xl">
            <Cookie size={18} className="text-white" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-display text-sm font-semibold mb-1">We use cookies</h3>
            <p className="text-xs text-gray-400 leading-relaxed mb-3">
              We use essential cookies to make our site work, and optional analytics cookies to understand how you use it. We never sell your data. See our{' '}
              <button className="text-teal-400 hover:text-teal-300 underline">Cookie Policy</button> and{' '}
              <button className="text-teal-400 hover:text-teal-300 underline">Privacy Policy</button> for details.
            </p>
            {showDetails && (
              <div className="mb-3 p-3 bg-gray-800 rounded-xl text-xs space-y-2">
                <div className="flex items-center justify-between">
                  <span>Essential cookies (required)</span>
                  <span className="text-green-400 font-medium">Always on</span>
                </div>
                <div className="flex items-center justify-between">
                  <span>Analytics cookies (Google Analytics)</span>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input type="checkbox" className="sr-only peer" defaultChecked />
                    <div className="w-8 h-4 bg-gray-600 peer-checked:bg-teal-600 rounded-full transition-colors" />
                  </label>
                </div>
                <div className="flex items-center justify-between">
                  <span>Marketing cookies</span>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input type="checkbox" className="sr-only peer" />
                    <div className="w-8 h-4 bg-gray-600 peer-checked:bg-teal-600 rounded-full transition-colors" />
                  </label>
                </div>
              </div>
            )}
            <div className="flex flex-wrap gap-2">
              <button
                onClick={() => setVisible(false)}
                className="px-4 py-2 bg-teal-600 hover:bg-teal-700 text-white text-xs font-semibold rounded-lg transition-all active:scale-95"
              >
                Accept All
              </button>
              <button
                onClick={() => setVisible(false)}
                className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white text-xs font-semibold rounded-lg transition-all active:scale-95"
              >
                Essential Only
              </button>
              <button
                onClick={() => setShowDetails(!showDetails)}
                className="px-4 py-2 text-gray-400 hover:text-white text-xs font-medium rounded-lg transition-all"
              >
                {showDetails ? 'Hide' : 'Manage'} Preferences
              </button>
            </div>
          </div>
          <button onClick={() => setVisible(false)} className="flex-shrink-0 p-1.5 text-gray-500 hover:text-white rounded-lg transition-colors">
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}